import { FC } from 'react'

// css

import './ModalInfoCard.css'

//

import { Col, Row } from 'react-bootstrap'

// img


import modalAlertImg from './../../asset/modals/modal-icon-alert.svg'

// components

import MyButtonModal from '../ui/MyButtonModal'

//


interface ModalInfoCardProps {
  title: string,
  qrCode: string,
  onClick: () => void
}

const ModalInfoCard: FC<ModalInfoCardProps> = ({ title, qrCode, onClick}) => {



  return (

      <div className='modal-info-container'>


        <div className='modal-info-card'>

          <Row className='d-flex flex-md-row flex-column modal-info-card-info'>
            <Col md={8} className='d-flex justify-content-center mt-3 mb-3'>
                  <div className='modal-info-card-title'>{title}</div>
            </Col>
            <Col md={4} className='d-flex justify-content-center mt-3 mb-4'>
                  <img className='modal-info-card-qrcode' src={qrCode} alt="" />
            </Col>
          </Row>

          <Col className='d-flex justify-content-center'>
                <MyButtonModal title='Продолжить' img='' imgAlt='' onClick={onClick}></MyButtonModal>
          </Col>


        </div>



      </div>




  )
}

export default ModalInfoCard